import { tagColors } from "@/components/tag/tag-colors";
export const PurchaseOrderEnum = {
  status: {
    DRAFT: 'draft',
    WAIT_REVIEW: 'waitReview',
    REJECTED: 'rejected',
    WAIT_ORDER: 'waitOrder',
    WAIT_ARRIVE: 'waitArrive',
    COMPLETED: 'completed',
    ABOLISHED: 'abolished',
  },
  settleOption: [
    {id: 'monthly', text: '月结',...tagColors.blueDark},
    {id: 'cash', text: '现结',...tagColors.orangeDark},
  ],
  statusOption: [
    { id: 'draft', text: '草稿', ...tagColors.blue},
    { id: 'waitReview', text: '待审核', ...tagColors.orange},
    { id: 'rejected', text: '已驳回', ...tagColors.red},
    { id: 'waitOrder', text: '待下单', ...tagColors.orange},
    { id: 'waitArrive', text: '待交货', ...tagColors.orange},
    { id: 'completed', text: '已完成', ...tagColors.green},
    { id: 'abolished', text: '已作废', ...tagColors.gray}
  ],
  logColumns: [
    {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '120px'},
    {id: 'opUser', header: '操作用户', field: 'createUserName', minWidth: '100px'},
    {id: 'op', header: '操作分类', field: 'option:op', options: [
        {id: 'save', text: '新增'},
        {id: 'update', text: '更新'},
        {id: 'saveArraignment', text: '新增并提审'},
        {id: 'updateArraignment', text: '修改并提审'},
        {id: 'arraignment', text: '提审'},
        {id: 'reviewYes', text: '审核通过'},
        {id: 'reviewNo', text: '审核不通过'},
        {id: 'under', text: '下单'},
        {id: 'fastInbound', text: '快捷入库'},
        {id: 'endDeliveryNote', text: '结束交货'},
        {id: 'abolished', text: '作废'},
        {id: 'saveDeliveryNote', text: '新增交货单'},
        {id: 'saveOrderChange', text: '新增变更单'},
        {id: 'purchaseInbound', text: '采购入库'},
      ],
      minWidth: '120px'},
    {id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '300px'}
  ]
};
